/* eslint-disable react-hooks/exhaustive-deps */

import { Alert, Box, Button, Card, CardContent, IconButton, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { MarkdownTextEditor } from 'ui/MarkdownTextEditor';
import { MarkdownToHtmlConverter } from 'ui/MarkdownToHtmlConverter';
import { useDebounce } from 'use-debounce';
import { useDispatch, useSelector } from 'react-redux';
import { getErrorCorrection, getStartScriptError } from 'redux/reducers/errorCorrections/selectors';
import {
	updateCommentRequest,
	updateProposedSolutionRequest,
	updateCommunicationWithClientRequest,
} from 'redux/reducers/errorCorrections/reducer';
import { EditedTextParameter } from './EdittedTextParameter';
import { ScriptsTable } from './ScriptsTable';
import { LaunchCorrectionScriptDialog } from './LaunchCorrectionScript/LaunchCorrectionScriptDialog';
import { LaunchCorrectionScript } from './LaunchCorrectionScript';
import { EasCard } from '../../../../ui/EasCard';
// import { error } from '../../ErrorsTable/error-data';

export const ErrorCorrection: FC = () => {
	const params = useParams<{ errorId?: string }>();
	const { errorId } = params;

	const dispatch = useDispatch();
	const error = useSelector(getErrorCorrection);
	const errorMessage = useSelector(getStartScriptError);

	const [proposedSolutionText, setProposedSolutionText] = useState<string>(
		error?.proposedSolution ?? '',
	);
	const [proposedSolutionTextDebounce] = useDebounce(proposedSolutionText, 600);
	useEffect(() => {
		if (!error) return;
		if (proposedSolutionTextDebounce !== error?.proposedSolution) {
			dispatch(
				updateProposedSolutionRequest({
					text: proposedSolutionTextDebounce,
					errorId: +(errorId ?? 0),
				}),
			);
		}
	}, [proposedSolutionTextDebounce]);

	const [communicationWithTheClient, setCommunicationWithTheClient] = useState<string>(
		error?.communicationWithClient ?? '',
	);
	const [communicationWithTheClientDebounce] = useDebounce(communicationWithTheClient, 600);
	useEffect(() => {
		if (!error) return;
		if (communicationWithTheClientDebounce !== error?.communicationWithClient) {
			dispatch(
				updateCommunicationWithClientRequest({
					text: communicationWithTheClientDebounce,
					errorId: +(errorId ?? 0),
				}),
			);
		}
	}, [communicationWithTheClientDebounce]);

	const [comments, setComments] = useState<string>(error?.comment ?? '');
	const [commentsDebounce] = useDebounce(comments, 600);
	useEffect(() => {
		if (!error) return;
		if (commentsDebounce !== error?.comment) {
			dispatch(updateCommentRequest({ text: commentsDebounce, errorId: +(errorId ?? 0) }));
		}
	}, [commentsDebounce]);

	const [openScriptDialog, setOpenScriptDialog] = useState(false);
	const handleOpenScriptDialog = () => {
		setOpenScriptDialog(true);
	};
	const handleCloseScriptDialog = () => {
		setOpenScriptDialog(false);
	};

	useEffect(() => {
		if (!error) return;
		setProposedSolutionText(error?.proposedSolution ?? '');
		setCommunicationWithTheClient(error?.communicationWithClient ?? '');
		setComments(error?.comment ?? '');
	}, [error]);

	return (
		<EasCard id="error-correction" title="Error Correction" action={<></>} loading={false}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 2,
				}}
			>
				<EditedTextParameter
					name="Proposed solution"
					value={proposedSolutionText}
					onChange={setProposedSolutionText}
				/>
				<EditedTextParameter
					name="Communication with the client"
					value={communicationWithTheClient}
					onChange={setCommunicationWithTheClient}
				/>
				<EditedTextParameter name="Comments" value={comments} onChange={setComments} />
				{error?.scriptHistory.length ? (
					<ScriptsTable />
				) : (
					<Typography
						sx={{
							fontWeight: 'bold',
						}}
						color="primary"
					>
						No Correction Scripts yet
					</Typography>
				)}
				{errorMessage && (
					<Alert
						severity="error"
						// variant="filled"
						sx={{
							color: '#541213',
							backgroundColor: '#FEE2E2',
							// backgroundImage: 'none',
						}}
					>
						{errorMessage}
					</Alert>
					// <Typography
					// 	sx={{
					// 		color: 'red',
					// 	}}
					// >
					// 	{errorMessage}
					// </Typography>
				)}
				<Button
					variant="contained"
					color="primary"
					sx={{
						textTransform: 'none',
						width: 'fit-content',
					}}
					onClick={handleOpenScriptDialog}
				>
					Launch correction script
				</Button>
			</Box>
			<LaunchCorrectionScript open={openScriptDialog} setClose={handleCloseScriptDialog} />
		</EasCard>
	);
};
